module.exports = __webpack_public_path__ + "static/media/dept-industry.0ee64ded.jpg";